import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-132" data-mp="2pe7eu3w4nl5a">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-133" data-mp="2bfzls727p3ze">
        <header className="mx-auto max-w-3xl text-center" data-id="element-134" data-mp="2bfg48rgh4hlw">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-135" data-mp="2ge13oonwix9a">
            ¿Reconoces alguna de estas situaciones?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-600 [text-wrap:pretty] md:text-xl" data-id="element-136" data-mp="26gcwv0d0tzar">
            Tanto si estás estudiando como si ya trabajas en Kinesiología o Fisioterapia,
            probablemente te resulte familiar.
          </p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-137" data-mp="1woqpxg7pumdt">
          {painPoints.map(point => <li key={point.title} className="flex h-full items-start gap-3 rounded-2xl bg-red-50 px-4 py-4 ring-1 ring-red-100 md:px-5" data-id="element-138" data-mp="1npvftt1jws58">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-139" data-mp="tbrn2jowvy6e">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-140" data-mp="12b50fng5p6we" />
              </span>
              <p className="leading-snug text-slate-700" data-id="element-141" data-mp="xbs5sgj1mvj9">
                <strong className="font-extrabold text-slate-900" data-id="element-142" data-mp="xcbk7n9hj1sj">{point.title}</strong>{' '}
                {point.description}
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 [text-wrap:balance] md:mt-12 md:text-4xl" data-id="element-143" data-mp="5lxg2ir9x3u2">
          No te falta información. Te falta tenerla organizada de forma visual.
        </p>
      </div>
    </section>;
}